
module.exports.activate_section_contact = () => {
    let DOM_section_contact_externsvg;
    DOM_section_contact_externsvg = document.querySelector('extern-svg[data-mountpoint="section_contact"]');
    if(DOM_section_contact_externsvg === null) return;

    DOM_section_contact_externsvg.addEventListener('svgready',
        (e)=>{
            let DOM_svg=e.target.querySelector(':scope svg');
            DOM_svg.addEventListener('contact_email_click',()=>{
                location.href = "mailto:nagoyaitalianoperacompetition@gmail.com";
            });

        }
    );
}
